module.exports = __webpack_public_path__ + "static/portraitClelia-1f0e9791309068f65d7220a3895f5513.jpg";